function updateTimerdeal() {
  future = Date.parse("july 4, 2024 12:00:00");
  now = new Date();
  diff = future - now;

  days = Math.floor(diff / (1000 * 60 * 60 * 24));
  hours = Math.floor(diff / (1000 * 60 * 60));
  mins = Math.floor(diff / (1000 * 60));
  secs = Math.floor(diff / 1000);

  d = days;
  h = hours - days * 24;
  m = mins - hours * 60;
  s = secs - mins * 60;

  document.getElementById("cosmo-countdown-timer").innerHTML =
    '<div class="cosmo-countdown-time-item">' +
    d +
    '<span class="cosmo-countdown-title">d<span class="cosmo-countdown-colon">:<span></span></div>' +
    '<div class="cosmo-countdown-time-item">' +
    h +
    '<span class="cosmo-countdown-title">h<span class="cosmo-countdown-colon">:<span></span></div>' +
    '<div class="cosmo-countdown-time-item">' +
    m +
    '<span class="cosmo-countdown-title">m<span class="cosmo-countdown-colon">:<span></span></div>' +
    '<div class="cosmo-countdown-time-item">' +
    s +
    '<span class="cosmo-countdown-title">s</div>';
}
setInterval("updateTimerdeal()", 1000);
